export default class DynamicDesktopToOverlaySwitcher {
  constructor(navbar) {
    this.navbar = navbar;
    this.ul = $(this.navbar).find(".page-navbar__menu > ul")[0];

    if (this.ul) {
      this._init();
    }
  }

  _init() {
    this.brand = $(this.navbar).find(".page-navbar__brand")[0];
    // event: init
    // this._setFixMenuItemWidths();
    this._handelWindowLoad();
  }

  _handelWindowLoad(evt) {
    // If the user can't hover always show the mobil-menu
    if (!window.matchMedia("(hover: hover)").matches) {
      this.navbar.classList.add("overlay-instead-of-desktop");
      this.useOverlayToggle = true;
      $(window).trigger("luther:overlay-instead-of-desktop", [true]);
      // if the user can hover calculate the mobile breakpoint
    } else {
      this._getMenuBreakpoint().then((resp) => {
        this.breakpoint = resp;
        window.addEventListener("resize", this._doSwitchIfNessesary.bind(this));
        this._doSwitchIfNessesary();
      });
    }
  }

  _getMenuBreakpoint() {
    return new Promise((resolve) => {
      let extraPadding = 220;
      let menuItems = 0;
      for (let menuItem of this.ul.children) {
        menuItems += menuItem.clientWidth;
      }
      let breakpoint = menuItems + this.brand.clientWidth + extraPadding;
      resolve(breakpoint);
    });
  }

  _handelWindowResize(evt) {
    this._doSwitchIfNessesary();
  }

  _doSwitchIfNessesary() {
    const useOverlayToggle = this.useOverlayToggle || false;
    if (window.innerWidth < this.breakpoint) {
      if (!useOverlayToggle) {
        this.navbar.classList.add("overlay-instead-of-desktop");
        this.useOverlayToggle = true;
        $(window).trigger("luther:overlay-instead-of-desktop", [true]);
      }
    } else {
      if (useOverlayToggle) {
        this.navbar.classList.remove("overlay-instead-of-desktop");
        this.useOverlayToggle = false;
        $(window).trigger("luther:overlay-instead-of-desktop", [false]);
      }
    }
  }

  _setFixMenuItemWidths() {
    for (let menuItem of this.ul.children) {
      menuItem.style.width = menuItem.clientWidth + 6 + "px";
    }
  }
}
